import React from "react";
import { TradeOrderInvestmentContainer } from "../../../containers";

const TransactionView = (props) => {
  return <TradeOrderInvestmentContainer {...props} />;
};

export default TransactionView;
